import {
  Email,
  Facebook,
  Instagram,
  Phone,
  YouTube,
} from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
const Footer = () => (
  <>
    <Box className="footer">
      <Grid container spacing={2} rowGap={2} sx={{ padding: "0px 20px" }}>
        <Grid item xs={12} md={6}>
          <Stack spacing={1}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Work Sans",
                fontSize: "18px",
                fontWeight: 500,
                lineHeight: "24px",
                letterSpacing: "0.02em",
                textAlign: "left",
              }}
            >
              Address-
            </Typography>
            <Typography
              variant="body2"
              sx={{
                alignItems: "center",
                fontFamily: "Work Sans",
                fontSize: "13px",
                fontWeight: 800,
                lineHeight: "22.2px",
                letterSpacing: "0.02em",
                textAlign: "left",
                width: {
                  xs: "100%",
                  md: "70%",
                },
              }}
            >
              LearnCap Academy Pvt. Ltd.
              <Typography sx={{
                fontFamily: "Work Sans",
                fontSize: "12px",
                fontWeight: 600,
                lineHeight: "22.2px",
              }}>
                286-B, Durga Devasthana, Thyavana Post, Thyavana, Chickmagalur,
                Sringeri, Karnataka, India, 577139.
              </Typography>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={3}>
          <Stack spacing={1}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Work Sans",
                fontSize: "18px",
                fontWeight: 500,
                lineHeight: "24px",
                letterSpacing: "0.02em",
                textAlign: "left",
              }}
            >
              Contact Us-
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Work Sans",
                fontSize: {
                  xs: "14px",
                  // md: "16px",
                },
                fontWeight: 600,
                lineHeight: "22.2px",
                letterSpacing: "0.02em",
                textAlign: "left",
              }}
            >
              <Phone sx={{ marginRight: 1 }} /> +91 9113993467
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Work Sans",
                fontSize: {
                  xs: "14px",
                  // md: "16px",
                },
                fontWeight: 600,
                lineHeight: "22.2px",
                letterSpacing: "0.02em",
                textAlign: "left",
                color: "#2E2E2E",
              }}
            >
              <Email sx={{ marginRight: 1 }} />
              <a
                href="mailto:sachin.k.kumar@Learncap.in, learncapacademy@gmail.com"
                style={{
                  textDecoration: "none",
                  color: "#2E2E2E",
                  flexWrap: "wrap",
                }}
              >
                learncapacademy@gmail.com
              </a>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Work Sans",
              fontSize: "18px",
              fontWeight: 500,
              lineHeight: "24px",
              letterSpacing: "0.02em",
              marginBottom: { xs: "0px", lg: "20px" },
              textAlign: {
                xs: "center",
                lg: "left",
              },
              margin: {
                xs: "10px",
                lg: "0px",
              },
              marginLeft: "20px",
            }}
          >
            Follow us on-
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: {
                xs: "space-between",
                sm: "center",
                md: "flex-start",
              },
              gap: {
                xs: 0,
                sm: 2,
                lg: 4,
                xl: 4,
              },
            }}
          >
            <IconButton
              href="https://www.linkedin.com/company/learncap-academy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon
                sx={{ color: "#2E2E2E", width: "36px", height: "36px" }}
              />
            </IconButton>
            <IconButton
              href="https://www.facebook.com/people/Learncap-Academy/61566640453355/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook
                sx={{ color: "#2E2E2E", width: "36px", height: "36px" }}
              />
            </IconButton>
            <IconButton
              href="https://www.youtube.com/@LearncapAcademy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTube
                sx={{ color: "#2E2E2E", width: "36px", height: "36px" }}
              />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  </>
);

export default Footer;
